const arr = [
    // 2月会员日
    {
        path: '/februaryMebDay',
        name: 'februaryMebDay',
        component: () => import(/* webpackChunkName:"activity-yearCheck"*/'@/pages/memberDayActivity/februaryMebDay/index.vue'),
        meta: {
            title: '亚朵温暖传递',
        },
    }, {
        // 列表详情
        path: '/februaryMebDayListDetail',
        component: () => import(/* webpackChunkName:"activity-yearCheck"*/'@/pages/memberDayActivity/februaryMebDay/showDetail.vue'),

        name: 'februaryMebDayListDetail',
        meta: {
            title: '亚朵战疫日记',
        },
    }, {
        // 通知
        path: '/februaryMebDayNotice',
        component: () => import(/* webpackChunkName:"activity-yearCheck"*/'@/pages/memberDayActivity/februaryMebDay/showDetail.vue'),

        name: 'februaryMebDayNotice',
        meta: {
            title: '亚朵会员等级延期公告',
        },
    },
];
export default arr;
